import { render, staticRenderFns } from "./dailyRestrictions.vue?vue&type=template&id=63be0321"
import script from "./dailyRestrictions.vue?vue&type=script&lang=js"
export * from "./dailyRestrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports